import { useState } from "react"
import { useLoad } from "../../context/useLoadContext"
import { useError } from "../../context/useErrorContext"
import { GetRequest, PostRequest } from "../../services/ApiClientService"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { type SignInResponseDto } from "../../Objects/Generics/SignInResponseDto"
import { useEmployerLogged } from "../../context/useEmployeeContext"
import { employeeMemory } from "../../Objects/Memory/Memory"
import { useGetEmployee } from "../Employee/useGetEmployee"
import { useTranslation } from "react-i18next"
import { AuthState } from "../../context/usePublicViewContext"
import { CourierAuthState } from "../../context/useCourierViewContext"

const useLogin = () => {
  const { t } = useTranslation("general")

  const [email, setEmail] = useState("")

  const [password, setPassword] = useState("")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { setEmployee } = useEmployerLogged()

  const { handleGetEmployee } = useGetEmployee()

  const handleLogin = async (event: React.FormEvent, onSuccess: () => void) => {
    event.preventDefault()

    enableLoad()

    try {
      const response = await PostRequest<SignInResponseDto>(API_ROUTES.AUTH.LOGIN, {
        username: email,
        password: password,
      })

      if (response.success) {
        localStorage.setItem(API_ROUTES.TOKEN, JSON.stringify(response.data?.token))

        localStorage.setItem(API_ROUTES.EMAIL_KEY, JSON.stringify(email))

        await handleGetEmployee(() => {})

        setEmployee(employeeMemory.findById(response.data!.id) ?? null)

        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  const HandleFastLogin = async (email: string, password: string, onSuccess: () => void) => {
    enableLoad()

    try {
      const response = await PostRequest<SignInResponseDto>(API_ROUTES.AUTH.LOGIN, {
        username: email,
        password: password,
      })

      if (response.success) {
        localStorage.setItem(API_ROUTES.TOKEN, JSON.stringify(response.data?.token))

        await handleGetEmployee(() => {})

        setEmployee(employeeMemory.findById(response.data!.id) ?? null)

        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  const HandleCustomerLogin = async (rote: string, onSuccess: (authState: AuthState) => void) => {
    enableLoad()

    try {
      const params = new URLSearchParams()

      params.append("filter", email)

      const response = await GetRequest<AuthState>(`${rote}?${params.toString()}`)

      if (response.success) {
        onSuccess(response.data)

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  const HandleCourierLogin = async (
    rote: string,
    emailParam: string,
    passwordParam: string,
    onSuccess: (authState: CourierAuthState) => void,
  ) => {
    enableLoad()

    try {
      const response = await PostRequest<CourierAuthState>(rote, {
        email: emailParam,
        password: passwordParam,
      })

      if (response.success) {
        onSuccess(response.data)
        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    email,
    password,
    setEmail,
    setPassword,
    handleLogin,
    HandleFastLogin,
    HandleCustomerLogin,
    HandleCourierLogin,
  }
}

export default useLogin
